module.exports = __webpack_public_path__ + "img/71.03520a54.jpg";